import { render, staticRenderFns } from "./CheckBig.vue?vue&type=template&id=290c288e&scoped=true&lang=pug"
import script from "./CheckBig.vue?vue&type=script&lang=js"
export * from "./CheckBig.vue?vue&type=script&lang=js"
import style0 from "./CheckBig.vue?vue&type=style&index=0&id=290c288e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290c288e",
  null
  
)

export default component.exports